import InnerComponent from '@Components/Sales/PackingSlip/PackingSlipList';
import orgContainer from '@Components/AppContainer';

const ListPackingSlip = () => ((orgContainer(InnerComponent)));
export default ListPackingSlip;